import * as React from 'react';
import { connect } from 'react-redux';
import { StyleRulesCallback, withStyles } from '@material-ui/core/styles';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core/'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import * as moment from 'moment';
import BreadCrumb from '../../shared/components/BreadCrumb'
import store from '../../../modules/core/store/index'
import { loadSubscriptionSuccess, loadSubscriptionStart } from '../../core/actions/subscriptionActions'
import TablePagination from '@material-ui/core/TablePagination'
import { bindActionCreators } from 'redux';
import RequestService from '../../core/services/SubscriptionRequestService'
import { NavLink } from 'react-router-dom';

const requestService = RequestService.Instance

const styles: StyleRulesCallback = (theme: any) => ({
  formControl: {
    minWidth: 200,
  },
});

interface IState {
  isLoading: boolean
  assetid: any
  assets: any
  assetName: any
  totalElements: number
  page: number
  elementsPerPage: number
}

class Verifications extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    const asset = this.props.match.params.asset;
    this.state = {
      isLoading: true,
      assetid: asset,
      assets: {},
      assetName: {},
      totalElements: 0,
      page: 0,
      elementsPerPage: 25
    }
  }

  public async componentDidMount() {
    store.dispatch(loadSubscriptionStart(this.state.assetid, this.props.match.params.live === "Live" ? 2 : 1, this.state.page + 1, this.state.elementsPerPage));

    const assetName = await requestService.getAsset(this.state.assetid);
    this.setState({ assetName })
  }


  public drawtable() {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Approval date </TableCell>
            <TableCell>Entity</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.props.subscriptions.subscriptions === 0 && <TableRow><TableCell colSpan={5} >No Subscription Requests</TableCell></TableRow>}
          {this.props.subscriptions.subscriptions && this.props.subscriptions.subscriptions.filter((s: any) => s.enviromentName === this.props.match.params.live)
            .map((request: any) => {
              return (
                <TableRow key={request.id}>
                  <TableCell title={moment(new Date(request.date)).format('YYYY-MM-DD, h:mm a')}>{moment(new Date(request.date)).fromNow()}</TableCell>
                  <TableCell component="th" scope="row">
                    {request.entityName}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {request.roles.length === 0 ? "no roles" : request.roles.map((role: any) => role.name + " ")}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {request.status}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Button color="secondary" component={(componentProps: any) => <NavLink {...componentProps} to={request.status === "Requested" ? 'verifications/' + request.id : "/subscriptiondetails/" + request.id} />} >
                      {request.status === "Requested" ? "verify" : "Details"}
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    )
  }


  public handlePageChange = (event: any, page: number) => {
    this.setState({
      page
    })
    store.dispatch(loadSubscriptionStart(this.state.assetid, this.props.match.params.live === "Live" ? 2 : 1, page + 1, this.state.elementsPerPage));
  };

  public handleChangeRowsPerPage = (event: any) => {
    this.setState({
      elementsPerPage: event.target.value
    })
    store.dispatch(loadSubscriptionStart(this.state.assetid, this.props.match.params.live === "Live" ? 2 : 1, this.state.page + 1, event.target.value));
  }

  public render() {
    const { subscriptions } = this.props;
    return (
      <div>
        <Typography variant="title" gutterBottom={true}>
          {this.state.assetName.name + " | " + this.props.match.params.live + " environment | Manage Subscriptions"}
        </Typography>
        <Typography color="textSecondary" gutterBottom>
          <BreadCrumb
            value='Console'
            to='/'
          />
          <BreadCrumb
            value='Assets'
            to='/verifications'
          />
          {this.state.assetName.name}
        </Typography>
        {!this.props.isLoading && this.drawtable()}
        <TablePagination
          component="div"
          count={subscriptions.page ? subscriptions.page.totalElements : 0}
          onChangePage={this.handlePageChange}
          page={this.state.page}
          rowsPerPage={this.state.elementsPerPage}
          rowsPerPageOptions={[10, 25, 50]}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </div>
    )
  }
}


function mapStateToProps(state: any) {
  return {
    subscriptions: state.subscriptionReducer,
    data: state,
    isLoading: state.isLoadingReducer,
    assets: state.assetReducer
  };
}

function mapDispatchToProps(dispatch: any) {
  return bindActionCreators(
    { loadSubscriptionSuccess },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Verifications));


// WEBPACK FOOTER //
// ./src/modules/subscription/pages/AssetSubscriptions.tsx